import { XStack, View, Text } from "tamagui";
import { RiInformationLine } from "react-icons/ri";
import { colors } from "@styles/colors";
import { useSkinV2Page, v2 } from "@screen/Home/pages/GasShop/skin";

type InfoTone = "primary" | "amber" | "danger";

interface InfoNoteProps {
  children: React.ReactNode;
  tone?: InfoTone;
  icon?: React.ReactNode;
}

const toneMap: Record<InfoTone, { bg: string; fg: string }> = {
  primary: { bg: colors.primaryBg, fg: colors.primaryText },
  amber: { bg: colors.bgAmber, fg: colors.amberDark },
  danger: { bg: colors.bgRed, fg: colors.redText },
};

/** 藍/琥珀/紅底的提示框 */
export default function InfoNote({ children, tone = "primary", icon }: InfoNoteProps) {
  const t = toneMap[tone];
  /**
   * V2：提示不是「另一種卡片」，而是頁面底下的一段註記。
   *
   * 原本是一塊有色底的圓角方塊，放在一排白卡之間會多出一個彩色的重心——尤其是每頁最後
   * 那句補充說明，明明是最不重要的一行，卻是整頁顏色最重的一塊。V2 改成無底色、
   * 灰字、圖示同色的註記；需要示警的 amber／danger 才保留有色底，那是語意不是裝飾。
   */
  const skinV2 = useSkinV2Page();
  const plain = skinV2 && tone === "primary";
  const fg = plain ? v2.sub : t.fg;
  return (
    <XStack
      bg={plain ? "transparent" : t.bg}
      br={skinV2 ? 16 : 12}
      px={plain ? "$1" : "$3.5"}
      py={plain ? "$1" : "$3"}
      gap="$2"
      ai="flex-start">
      <View mt={plain ? 1 : "$0.5"} flexShrink={0}>
        {icon ?? <RiInformationLine size={14} color={fg} />}
      </View>
      <Text f={1} fontSize={11.5} color={fg} lineHeight={18}>
        {children}
      </Text>
    </XStack>
  );
}
